/* manuka-r43 — PDP-Galerie: Zoom-Origin am Cursor, ms-anim-Klasse.
   Der Crossfade selbst ist reines CSS (manuka-r43.css) über Flickitys
   .is-selected. Ohne JS oder unter prefers-reduced-motion passiert nichts. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) return;

  root.classList.add('ms-anim');

  if (document.body.classList.contains('template-product')) return;

  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function bindZoomOrigin(gallery) {
    if (gallery.dataset.msR43) return;
    gallery.dataset.msR43 = '1';

    if (!fine) return;

    gallery.addEventListener('mousemove', function (evt) {
      var wrap = evt.target.closest('.product-main-slide .image-wrap');
      if (!wrap) return;
      var box = wrap.getBoundingClientRect();
      if (!box.width || !box.height) return;
      var x = ((evt.clientX - box.left) / box.width) * 100;
      var y = ((evt.clientY - box.top) / box.height) * 100;
      wrap.style.setProperty('--ms-zoom-origin', x.toFixed(1) + '% ' + y.toFixed(1) + '%');
    });

    gallery.addEventListener('mouseleave', function () {
      var wraps = gallery.querySelectorAll('.product-main-slide .image-wrap');
      for (var i = 0; i < wraps.length; i++) wraps[i].style.removeProperty('--ms-zoom-origin');
    }, true);
  }

  function init() {
    var galleries = document.querySelectorAll('[id^="ProductPhotos"]');
    for (var i = 0; i < galleries.length; i++) bindZoomOrigin(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Quick-Shop / Section-Rerender: neue Galerien nachbinden. */
  document.addEventListener('shopify:section:load', init);
})();
